module.exports = __webpack_public_path__ + "static/img/FBS-F3eJZ9B7.fa52826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/FBS-F3eJZ9B7.png
// module id = SJOA
// module chunks = 16